import { render, staticRenderFns } from "./ClientServices.vue?vue&type=template&id=3c9a2ff3&"
import script from "./ClientServices.vue?vue&type=script&lang=js&"
export * from "./ClientServices.vue?vue&type=script&lang=js&"
import style0 from "./ClientServices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports